/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsMarketBarcodeVo } from './GoodsMarketBarcodeVo';
import {
    GoodsMarketBarcodeVoFromJSON,
    GoodsMarketBarcodeVoFromJSONTyped,
    GoodsMarketBarcodeVoToJSON,
    GoodsMarketBarcodeVoToJSONTyped,
} from './GoodsMarketBarcodeVo';
import type { ParcelVo } from './ParcelVo';
import {
    ParcelVoFromJSON,
    ParcelVoFromJSONTyped,
    ParcelVoToJSON,
    ParcelVoToJSONTyped,
} from './ParcelVo';
import type { ComposedGoodsVo } from './ComposedGoodsVo';
import {
    ComposedGoodsVoFromJSON,
    ComposedGoodsVoFromJSONTyped,
    ComposedGoodsVoToJSON,
    ComposedGoodsVoToJSONTyped,
} from './ComposedGoodsVo';

/**
 * 
 * @export
 * @interface OrderDetailOrderDetailGoodsVo
 */
export interface OrderDetailOrderDetailGoodsVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    id?: number;
    /**
     * 快递列表
     * @type {Array<ParcelVo>}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    parcels?: Array<ParcelVo>;
    /**
     * 采购平台订单号
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    purchasePlatformOrderNo?: string;
    /**
     * 商品网站url
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    url?: string;
    /**
     * CO商品名称（英文）
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    coGoodsNameEn?: string;
    /**
     * CO海关编码
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    coHsCode?: string;
    /**
     * 产地证类型 三种取值  FTA APAC RCEP
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    hsCodeType?: string;
    /**
     * 商品数量
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    initQuantity?: number;
    /**
     * 颜色
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    size?: string;
    /**
     * 商品状态名称
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    goodsStatusName?: string;
    /**
     * 入库商品名
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    marketProNm?: string;
    /**
     * 商品选项名
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    marketOptionName?: string;
    /**
     * 商品选项ID
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    marketOptionId?: string;
    /**
     * 商品入库条码
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    marketBarcode?: string;
    /**
     * 当前订单商品的平台条码快照列表
     * @type {Array<GoodsMarketBarcodeVo>}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    marketBarcodes?: Array<GoodsMarketBarcodeVo>;
    /**
     * 原产地
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    origin?: string;
    /**
     * 商品到期日期 yyyy-MM-dd
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    marketExpiryDate?: string;
    /**
     * 备注留言
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    remark?: string;
    /**
     * 商品重量
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    weight?: number;
    /**
     * 商品CBM
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    cbm?: number;
    /**
     * 商品名称
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    name?: string;
    /**
     * 商品图片url
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    imgUrl?: string;
    /**
     * SKU ID
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    skuId?: number;
    /**
     * SKU编码
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    skuCode?: string;
    /**
     * 国内运输费用
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    chinaDomesticShippingFee?: number;
    /**
     * 采购税
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    purchaseTax?: number;
    /**
     * 开发票公司名称
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    invoiceCompany?: string;
    /**
     * 货车入库号
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    truckInboundNumber?: string;
    /**
     * 车辆信息
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    vehicleInformation?: string;
    /**
     * 司机电话
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    driverTelephone?: string;
    /**
     * 托盘数量
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    palletNumber?: number;
    /**
     * 箱数量
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    boxNumber?: number;
    /**
     * 到达时间
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    arrivedTime?: string;
    /**
     * 商品编码
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    code?: string;
    /**
     * 商品总金额（人民币）
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    totalPriceCny?: number;
    /**
     * 商品总金额（美元）
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    totalPriceUsd?: number;
    /**
     * 商品单价
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    unitPrice?: number;
    /**
     * 商品总金额（韩元）
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    totalPrice?: number;
    /**
     * 原始商品总金额（人民币）
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    originTotalPriceCny?: number;
    /**
     * 原始商品总金额（美元）
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    originTotalPriceUsd?: number;
    /**
     * 原始商品单价
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    originUnitPrice?: number;
    /**
     * 原始商品总金额（韩元）
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    originTotalPrice?: number;
    /**
     * 附加费用
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    additionalFee?: number;
    /**
     * 商品货位号列表
     * @type {Array<string>}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    locations?: Array<string>;
    /**
     * 运单号类型
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    trackNoType?: string;
    /**
     * 运单号类型码 1 中国快递单号 显示parcels, 2 韩国快递单号  显示parcels, 3 入库证编号 显示truckInboundNumber, 4 中国库存编号 显示stockIds, 5 韩国库存编号 显示stockIds
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    trackNoTypeCode?: number;
    /**
     * 通关类目id
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    ctmsItemId?: number;
    /**
     * 通关类目（韩文）
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    itemNameKr?: string;
    /**
     * 通关类目（英文）
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    itemNameEn?: string;
    /**
     * 通关类目（中文）
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    itemNameCn?: string;
    /**
     * 是否打印原产地 0 不打印 1 打印
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    originPrint?: number;
    /**
     * 是否合包商品 0 不是 1 是
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    combined?: number;
    /**
     * 当前基础商品实际参与且允许修改数量的合包目标，按持久化组成关系关联
     * @type {Array<ComposedGoodsVo>}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    quantityModifyTargets?: Array<ComposedGoodsVo>;
    /**
     * 组成商量
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    constructCount?: number;
    /**
     * 是否样品商品 0 不是 1 是
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    simple?: number;
    /**
     * 商品来源类型 1 普通url下单 2 sku下单 3 库存下单 4 复制购物车
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    sourceType?: number;
    /**
     * 合包商品ID
     * @type {number}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    parentId?: number;
    /**
     * 购买商品的所在平台的url
     * @type {string}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    purchasePlatformUrl?: string;
    /**
     * 库存ID列表
     * @type {Array<number>}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    stockIds?: Array<number>;
    /**
     * 韩国3pl库存货位号列表
     * @type {Array<string>}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    kr3plStockLocations?: Array<string>;
    /**
     * 管理端订单详情商品列表可以显示的按钮
     * @type {Array<string>}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    adminOrderDetailGoodsButtons?: Array<string>;
    /**
     * 客户订单详情商品列表可以显示的按钮
     * @type {Array<string>}
     * @memberof OrderDetailOrderDetailGoodsVo
     */
    clientOrderDetailGoodsButtons?: Array<string>;
}

/**
 * Check if a given object implements the OrderDetailOrderDetailGoodsVo interface.
 */
export function instanceOfOrderDetailOrderDetailGoodsVo(value: object): value is OrderDetailOrderDetailGoodsVo {
    return true;
}

export function OrderDetailOrderDetailGoodsVoFromJSON(json: any): OrderDetailOrderDetailGoodsVo {
    return OrderDetailOrderDetailGoodsVoFromJSONTyped(json, false);
}

export function OrderDetailOrderDetailGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDetailOrderDetailGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'parcels': json['parcels'] == null ? undefined : ((json['parcels'] as Array<any>).map(ParcelVoFromJSON)),
        'purchasePlatformOrderNo': json['purchasePlatformOrderNo'] == null ? undefined : json['purchasePlatformOrderNo'],
        'url': json['url'] == null ? undefined : json['url'],
        'coGoodsNameEn': json['coGoodsNameEn'] == null ? undefined : json['coGoodsNameEn'],
        'coHsCode': json['coHsCode'] == null ? undefined : json['coHsCode'],
        'hsCodeType': json['hsCodeType'] == null ? undefined : json['hsCodeType'],
        'initQuantity': json['initQuantity'] == null ? undefined : json['initQuantity'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'goodsStatusName': json['goodsStatusName'] == null ? undefined : json['goodsStatusName'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketBarcodes': json['marketBarcodes'] == null ? undefined : ((json['marketBarcodes'] as Array<any>).map(GoodsMarketBarcodeVoFromJSON)),
        'origin': json['origin'] == null ? undefined : json['origin'],
        'marketExpiryDate': json['marketExpiryDate'] == null ? undefined : json['marketExpiryDate'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'name': json['name'] == null ? undefined : json['name'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'chinaDomesticShippingFee': json['chinaDomesticShippingFee'] == null ? undefined : json['chinaDomesticShippingFee'],
        'purchaseTax': json['purchaseTax'] == null ? undefined : json['purchaseTax'],
        'invoiceCompany': json['invoiceCompany'] == null ? undefined : json['invoiceCompany'],
        'truckInboundNumber': json['truckInboundNumber'] == null ? undefined : json['truckInboundNumber'],
        'vehicleInformation': json['vehicleInformation'] == null ? undefined : json['vehicleInformation'],
        'driverTelephone': json['driverTelephone'] == null ? undefined : json['driverTelephone'],
        'palletNumber': json['palletNumber'] == null ? undefined : json['palletNumber'],
        'boxNumber': json['boxNumber'] == null ? undefined : json['boxNumber'],
        'arrivedTime': json['arrivedTime'] == null ? undefined : json['arrivedTime'],
        'code': json['code'] == null ? undefined : json['code'],
        'totalPriceCny': json['totalPriceCny'] == null ? undefined : json['totalPriceCny'],
        'totalPriceUsd': json['totalPriceUsd'] == null ? undefined : json['totalPriceUsd'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'totalPrice': json['totalPrice'] == null ? undefined : json['totalPrice'],
        'originTotalPriceCny': json['originTotalPriceCny'] == null ? undefined : json['originTotalPriceCny'],
        'originTotalPriceUsd': json['originTotalPriceUsd'] == null ? undefined : json['originTotalPriceUsd'],
        'originUnitPrice': json['originUnitPrice'] == null ? undefined : json['originUnitPrice'],
        'originTotalPrice': json['originTotalPrice'] == null ? undefined : json['originTotalPrice'],
        'additionalFee': json['additionalFee'] == null ? undefined : json['additionalFee'],
        'locations': json['locations'] == null ? undefined : json['locations'],
        'trackNoType': json['trackNoType'] == null ? undefined : json['trackNoType'],
        'trackNoTypeCode': json['trackNoTypeCode'] == null ? undefined : json['trackNoTypeCode'],
        'ctmsItemId': json['ctmsItemId'] == null ? undefined : json['ctmsItemId'],
        'itemNameKr': json['itemNameKr'] == null ? undefined : json['itemNameKr'],
        'itemNameEn': json['itemNameEn'] == null ? undefined : json['itemNameEn'],
        'itemNameCn': json['itemNameCn'] == null ? undefined : json['itemNameCn'],
        'originPrint': json['originPrint'] == null ? undefined : json['originPrint'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'quantityModifyTargets': json['quantityModifyTargets'] == null ? undefined : ((json['quantityModifyTargets'] as Array<any>).map(ComposedGoodsVoFromJSON)),
        'constructCount': json['constructCount'] == null ? undefined : json['constructCount'],
        'simple': json['simple'] == null ? undefined : json['simple'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'purchasePlatformUrl': json['purchasePlatformUrl'] == null ? undefined : json['purchasePlatformUrl'],
        'stockIds': json['stockIds'] == null ? undefined : json['stockIds'],
        'kr3plStockLocations': json['kr3plStockLocations'] == null ? undefined : json['kr3plStockLocations'],
        'adminOrderDetailGoodsButtons': json['adminOrderDetailGoodsButtons'] == null ? undefined : json['adminOrderDetailGoodsButtons'],
        'clientOrderDetailGoodsButtons': json['clientOrderDetailGoodsButtons'] == null ? undefined : json['clientOrderDetailGoodsButtons'],
    };
}

export function OrderDetailOrderDetailGoodsVoToJSON(json: any): OrderDetailOrderDetailGoodsVo {
    return OrderDetailOrderDetailGoodsVoToJSONTyped(json, false);
}

export function OrderDetailOrderDetailGoodsVoToJSONTyped(value?: OrderDetailOrderDetailGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'parcels': value['parcels'] == null ? undefined : ((value['parcels'] as Array<any>).map(ParcelVoToJSON)),
        'purchasePlatformOrderNo': value['purchasePlatformOrderNo'],
        'url': value['url'],
        'coGoodsNameEn': value['coGoodsNameEn'],
        'coHsCode': value['coHsCode'],
        'hsCodeType': value['hsCodeType'],
        'initQuantity': value['initQuantity'],
        'color': value['color'],
        'size': value['size'],
        'goodsStatusName': value['goodsStatusName'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'marketBarcode': value['marketBarcode'],
        'marketBarcodes': value['marketBarcodes'] == null ? undefined : ((value['marketBarcodes'] as Array<any>).map(GoodsMarketBarcodeVoToJSON)),
        'origin': value['origin'],
        'marketExpiryDate': value['marketExpiryDate'],
        'remark': value['remark'],
        'weight': value['weight'],
        'cbm': value['cbm'],
        'name': value['name'],
        'imgUrl': value['imgUrl'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'chinaDomesticShippingFee': value['chinaDomesticShippingFee'],
        'purchaseTax': value['purchaseTax'],
        'invoiceCompany': value['invoiceCompany'],
        'truckInboundNumber': value['truckInboundNumber'],
        'vehicleInformation': value['vehicleInformation'],
        'driverTelephone': value['driverTelephone'],
        'palletNumber': value['palletNumber'],
        'boxNumber': value['boxNumber'],
        'arrivedTime': value['arrivedTime'],
        'code': value['code'],
        'totalPriceCny': value['totalPriceCny'],
        'totalPriceUsd': value['totalPriceUsd'],
        'unitPrice': value['unitPrice'],
        'totalPrice': value['totalPrice'],
        'originTotalPriceCny': value['originTotalPriceCny'],
        'originTotalPriceUsd': value['originTotalPriceUsd'],
        'originUnitPrice': value['originUnitPrice'],
        'originTotalPrice': value['originTotalPrice'],
        'additionalFee': value['additionalFee'],
        'locations': value['locations'],
        'trackNoType': value['trackNoType'],
        'trackNoTypeCode': value['trackNoTypeCode'],
        'ctmsItemId': value['ctmsItemId'],
        'itemNameKr': value['itemNameKr'],
        'itemNameEn': value['itemNameEn'],
        'itemNameCn': value['itemNameCn'],
        'originPrint': value['originPrint'],
        'combined': value['combined'],
        'quantityModifyTargets': value['quantityModifyTargets'] == null ? undefined : ((value['quantityModifyTargets'] as Array<any>).map(ComposedGoodsVoToJSON)),
        'constructCount': value['constructCount'],
        'simple': value['simple'],
        'sourceType': value['sourceType'],
        'parentId': value['parentId'],
        'purchasePlatformUrl': value['purchasePlatformUrl'],
        'stockIds': value['stockIds'],
        'kr3plStockLocations': value['kr3plStockLocations'],
        'adminOrderDetailGoodsButtons': value['adminOrderDetailGoodsButtons'],
        'clientOrderDetailGoodsButtons': value['clientOrderDetailGoodsButtons'],
    };
}

